import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React  from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddResourceMutation,useGetCourseListQuery} from "../../../Services/api";

export default function Create() {
    const validationSchema = Yup.object().shape({
        coursecode: Yup.string().required("course name fields is required"),
        resources_name: Yup.string().required("name fields is required"),
        resources_type: Yup.string().required("type fields is required"),
        resources_link: Yup.string().required("resource link  fields is required"),
    });
   
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();

    const [addResource,isLoading] = useAddResourceMutation();
    const onSubmit = (values,e) => {
        const formData = new FormData();
        formData.append('coursecode', values.coursecode);
        formData.append('resources_name', values.resources_name);
        formData.append('resources_type', values.resources_type);
        if(showLink==='1'){
            formData.append('file', values.resource_file[0]);
            formData.append('type','resource');
        }
        else{
            formData.append('resources_link', values.resources_link);
        }
       
       
        ///
        addResource( formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    const [showLink, setShowLink] = React.useState('0')
    let link_types = "";
    if(showLink==='1'){
        link_types= <div className="row mb-3">
        <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources file</label>
        <div className="col-sm-10">
            <input type="file" {...register("resource_file",{required:true})} className="form-control" />
            <span className="text-danger">{errors.resource_file?.message}</span>
        </div>
        </div>
    }
    else if(showLink==='2'){
        link_types= <div className="row mb-3">
        <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources link</label>
        <div className="col-sm-10">
            <input type="name" {...register("resources_link",{required:true})} className="form-control" />
           
        </div>
        </div>
    }
   
    const resourcesType = (e) =>{
        setShowLink(e.target.value)  
    } 
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Resource</h5>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                            <div className="col-sm-10">
                               <select  {...register("coursecode", { required: true })} className="form-control" >
                                 <option value="">Select Course</option>                                           

                                {                            
                                getCourseList?.data?.map((item) => {
                                    return (
                                        <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                {errors.coursecode && <span  className="text-danger">Course is required</span>}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources Name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("resources_name",{ required: true })} className="form-control" />
                                {errors.resources_name && <span  className="text-danger">resources name is required</span>}

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources Type</label>
                            <div className="col-sm-10">
                                <select  {...register("resources_type",{ required: true })} className="form-control" onChange={resourcesType}>
                                 <option value="">Select Type</option>  
                                 <option value="1">File</option>                                           
                                 <option value="2">Url Link</option>  
                                </select>
                                {errors.resources_type && <span  className="text-danger">resources type is required</span>}

                            </div>
                        </div>
                        { link_types }
                       
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-10">
                            {isLoading.status !='pending' ? 
                                                
                            <button type="submit" className="btn btn-warning w-100" >Add Resource</button>
                            :
                            <button className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                            }
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </div>
    );
}